import '../../../vendor/js/jquery.validate/jquery.validate.js';
import '../../../vendor/js/jquery.validate/jquery.validate.unobtrusive.js';

// Extend jquery range validator to work for required checkboxes
var defaultRangeValidator = $.validator.methods.range;
$.validator.methods.range = function (value, element, param) {
    if (element.type === 'checkbox') {
        // if it's a checkbox return true if it is checked
        return element.checked;
    } else {
        // otherwise run the default validation function
        return defaultRangeValidator.call(this, value, element, param);
    }
}

// Add method for max filesize of a input file field
$.validator.addMethod('maxsize', function (value, element, param) {
    var isOptional = this.optional(element),
    file;

    if(isOptional) {
        return isOptional;
    }

    if ($(element).attr("type") === "file") {
         const maxFileSize = $(element).data('size-max') || 1048576; // 1MB;
        if (element.files && element.files.length) {

            file = element.files[0];
            return ( file.size && file.size <= maxFileSize );
        }
    }
    return false;
});

// Add method for strict filename matching of a input file field
$.validator.addMethod('strict-filename', function (value, element, param) {
    const isOptional = this.optional(element);
    if (isOptional) {
        return isOptional;
    }

    if ($(element).attr("type") === "file") {
        if (element.files && element.files.length) {
            const file = element.files[0];
            return /^[A-Za-z0-9_\.\s]+$/.test(file.name);
        }
    }
    return false;
});

// Add method for strict filename matching of a input file field
$.validator.addMethod('strict-filetype', function (value, element, param) {
    const isOptional = this.optional(element);
    if (isOptional) {
        return isOptional;
    }

    const allowed = [
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
        'application/rtf',
        'text/rtf',
        'application/msword',
        'application/pdf',
        'application/x-pdf',
        'application/x-bzpdf',
        'application-gzpdf',
    ];

    if ($(element).attr("type") === "file") {
        if (element.files && element.files.length) {
            const file = element.files[0];
            return allowed.includes(file.type);
        }
    }
    return false;
});

// Add methods to unobtrusive adapter
$.validator.unobtrusive.adapters.addBool('maxsize');
$.validator.unobtrusive.adapters.addBool('strict-filename');
$.validator.unobtrusive.adapters.addBool('strict-filetype');
